import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("rf_user") || "null"); } catch { return null; }
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("rf_token");
    if (!token) { setReady(true); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("rf_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("rf_token"); localStorage.removeItem("rf_user"); setUser(null); })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("rf_token", data.token);
    localStorage.setItem("rf_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("rf_token", data.token);
    localStorage.setItem("rf_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("rf_token");
    localStorage.removeItem("rf_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, ready }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
